import { api } from "@/api";

class API {
  static getReasonList(payload) {
    return api.get(`/v1/motivoscancelamento/`, { params: payload });
  }

  static getReason(id) {
    return api.get(`/v1/motivoscancelamento/${id}/`);
  }

  static postReason(payload) {
    return api.post(`/v1/motivoscancelamento/`, payload);
  }

  static putReason({ id, payload }) {
    return api.put(`/v1/motivoscancelamento/${id}`, payload);
  }
}

export default API;
